// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueQuillEditor from 'vue-quill-editor'
import 'element-ui/lib/theme-chalk/index.css'
import 'codemirror/lib/codemirror.css'

import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from 'v-click-outside'
 
import router from './router/router'
import store from './store/store'

import './styles'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueAxios, axios)
Vue.use(VueQuillEditor)
Vue.use(vClickOutside)

if ( process.env.NODE_ENV === 'development' ) {
  Vue.axios.defaults.baseURL = 'https://localhost/'
}

/* eslint-disable no-new */
new Vue({
  store,
  router,
  ...App,
}).$mount('#app')
